import React, { Component } from "react";

require("@fancyapps/fancybox");

export default class extends Component {
  imgRef;

  constructor(props) {
    super(props);
    $(this.imgRef).fancybox({
      openEffect: 'elastic',
      closeEffect: 'elastic'
    });
  }

  render() {
    const thumbUrl = _.replace(this.props.src, ".png", "") + " thumbnail.png";
    return <a data-fancybox href={this.props.src}>
      <img
        // src={}
        src={this.props.withoutThumbnail ? this.props.src : thumbUrl}
        className={this.props.className}
        ref={(it) => this.imgRef = it}
        alt={this.props.alt}/>
    </a>;
  }
}